import { useHistory } from "react-router-dom";
import { CardText, Eject, GeoAlt, PhoneVibrate, TelephoneOutbound, ArrowRightSquare } from 'react-bootstrap-icons';
import { setRejectServicePopup, setReferServicePopup } from "../../store/api/Services";
import { useDispatch } from "react-redux";
function TaskItem(props) {
    const { item, Rejectable, Referrable } = props;

    const history = useHistory();
    const dispatch = useDispatch();
    const showRejectPop = () => {
        dispatch(setRejectServicePopup({ show: true, serviceID: item.ServiceID, serviceType: item.ServiceType }));
    }
    const showReferPop = () => {
        dispatch(setReferServicePopup({ show: true, serviceID: item.ServiceID, serviceType: item.ServiceType }));
    }
    const showService = () => {
        history.push(`/Services/Service/${item.ServiceID}/${item.ServiceType}`, null);
    }

    return (
        <div className="col-md-4">
            <div className="card mt-2" style={{ backgroundColor: "rgb(206 206 207)", textAlign: "justify", boxShadow: '0px 0px 4px #070d35' }}>
                <div className="card card-header" style={{ boxShadow: '0px 0px 4px #070d35', fontWeight: "bold", fontSize: "13px" }}><span><span style={{ backgroundColor: item.BackgroundColor, marginLeft: "5px", borderRadius: "2px", width: "20px", display: "inline-block" }}>&nbsp;</span><span>سرویس {item.ServiceType.replace("install", "نصب").replace("repair", "تعمیر")} شماره {item.InvoiceNumber}</span></span></div>
                <div className="card-body row" style={{ color: 'black' }}>
                    <div className="col-5 mt-2" > نام محصول </div><div className="col-7 mt-2"> {item.ProductName} </div>
                    <div className="col-5 mt-2"> مدل محصول </div><div className="col-7 mt-2"> {item.ProductModel} </div>
                    <div className="col-5 mt-2"> شماره سریال</div><div className="col-7 mt-2"> {item.SerialNumber} </div>
                    <div className="col-5 mt-2"> نام مشتری</div><div className="col-7 mt-2"> {item.CustomerName} </div>
                    <div className="col-5 mt-2"> موبایل مشتری</div><div className="col-7 mt-2"> {item.CustomerMobile} {item.CustomerMobile.length > 8 && <a style={{ color: "red" }} href={'tel:' + item.CustomerMobile}><PhoneVibrate size={21} /></a>}</div>
                    <div className="col-5 mt-2"> تلفن مشتری</div><div className="col-7 mt-2"> {item.CustomerPhone}{item.CustomerPhone.length > 8 && <a style={{ color: "red" }} href={'tel:' + item.CustomerPhone}> <TelephoneOutbound size={18} /></a>}</div>
                    <div className="col-5 mt-2"> آدرس مشتری</div><div className="col-7 mt-2"> {item.ServiceAddress} </div>
                </div>
                <div className="row" style={{ padding: "5px", paddingRight: "10px" }}>
                    <div >
                        <button className="btn btn-block btn-success group-Btn" onClick={showService}><CardText size={20} /> نمایش </button>
                        {Rejectable && <button className="btn btn-block btn-danger group-Btn" onClick={showRejectPop}><Eject size={20} /> رد </button>}
                        <button className="btn btn-block btn-primary group-Btn" ><GeoAlt size={20} /><a style={{ color: "White" }} href={'https://maps.google.com/?q=' + item.Latitude + ',' + item.Longitude} target="_blank"> مسیر </a></button>
                        {Referrable && <button className="btn btn-block btn-primary group-Btn" style={{ backgroundColor: "#bd4906", borderColor: "#bd4906" }} onClick={showReferPop}><ArrowRightSquare size={16} /> ارجاع </button>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TaskItem;